module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/activity-logo-c0c782438c4a42065fa36788e3818a56.svg";